import { render, staticRenderFns } from "./DevolutionCoupons.vue?vue&type=template&id=5990f2df&lang=pug"
import script from "./DevolutionCoupons.vue?vue&type=script&lang=js"
export * from "./DevolutionCoupons.vue?vue&type=script&lang=js"
import style0 from "./DevolutionCoupons.vue?vue&type=style&index=0&id=5990f2df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports